import { getHtmlRequest, postHtmlRequest } from "../utils/fetch";

const basePath = "/apicore/popupapi/";

export function getPopupHtml(view: string, data?: any): Promise<string> {
	if (data) {
		return postHtmlRequest(basePath + view, data, {
			headers: new Headers({ "Content-type": "application/json; charset=utf-8" }),
		});
	} else {
		return getHtmlRequest(basePath + view, {
			headers: new Headers({ "Content-type": "application/json; charset=utf-8" }),
		});
	}
}
